import { ActionType } from '@adage/ace-calendar';

export class ExtendedActionType extends ActionType {
    static get ClearSelectedFilterOptions() {
        return "ClearSelectedFilterOptions";
    }

    static get SelectFilterOption() {
        return "SelectFilterOption";
    }

    static get GoToGridView() {
        return "GoToGridView";
    }

    static get GoToListView() {
        return "GoToListView";
    }

    static get AddNewImagesToLoad() {
        return "AddNewImagesToLoad";
    }

    static get RequestCalendarText() {
        return "RequestCalendarText";
    }

    static get ReceiveCalendarText() {
        return "ReceiveCalendarText()";
    }

    static get UpdateMonthElements() {
        return "UpdateMonthElements";
    }

    static get ClearMonthElements() {
        return "ClearMonthElements";
    }

    static get WaitForImage() {
        return "WaitForImage";
    }

    static get ImageHasLoaded() {
        return "ImageHasLoaded";
    }

    static get SetLastMonthToDisplay() {
        return "SetLastMonthToDisplay";
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/redux/actions/extended-actiontype.ts